<template>
  <div
    @click.stop.prevent="toggleDropdown"
    @mouseover="hoverActive = true"
    @mouseout="hoverActive = false"
    :class="[
      'dropdown__new-list',
      { 'dropdown__new-list--active': dropdownActive },
      { 'disabled-drop': disabled }
    ]"
    v-click-outside="() => (dropdownActive = false)"
  >
    <div
      class="three-select-schools__title"
      v-if="selectedElements.length === 1"
    >
      <!-- <div class="scool-logo">
        <img :src="checkAvatar(selectedElements[0].avatar)" alt="" />
      </div> -->
      <span>{{ selectedElements[0].title }}</span>
      <!-- <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M4.16797 7.5L10.0013 13.3333L15.8346 7.5"
          stroke="#8E9EBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg> -->

      <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M3.33301 6L7.99967 10.6667L12.6663 6"
          stroke="#5A6F95"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div
      class="three-select-schools__title"
      v-if="selectedElements.length === 0"
    >
      <span class="select-title">{{ title }}</span>
      <!-- <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M4.16797 7.5L10.0013 13.3333L15.8346 7.5"
          stroke="#8E9EBB"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg> -->

      <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M3.33301 6L7.99967 10.6667L12.6663 6"
          stroke="#5A6F95"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="three-select-schools__title" v-if="selectedElements.length > 1">
      <!-- <div class="multi-logo" v-if="selectedElements.length <= 3">
       <div
          v-for="avatar in selectedElements.slice(0, 3)"
          :key="avatar.id"
          class="scool-logo"
        >
        </div>
      </div> -->
      <span class="more-avatars"> {{ selectedElements.length }}+ מסגרות </span>
      <svg
        class="new-list"
        :class="{ 'new-list--active': dropdownActive, hovered: hoverActive }"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          :class="{ 'path-hovered': hoverActive }"
          d="M3.33301 6L7.99967 10.6667L12.6663 6"
          stroke="#5A6F95"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div v-show="dropdownActive" class="dropdown__list__custom">
      <!-- <div class="filter-block" :class="{ active: active_filter }">
        <div class="filter-block__header">
          <h4 class="filter-block__title" style="color: #929baa">מסנן</h4>
          <button class="filter-block__clear-button" @click.stop="clear_filter">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.3158 4H13.6842V7.5H20V11H4V7.5H10.3158V4Z"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 20H19V11H5V20Z"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linejoin="round"
              />
              <path
                d="M8.5 20V16"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 20V16"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.5 20V16"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.94727 20H17.0525"
                stroke="#929BAA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            נקה הכל
          </button>
        </div>
        <div class="filter-block__body" @click.stop>
          <div class="form__field mb-2">
            <div class="form__field-label">רשות</div>
            <CustomThreeSelect
              v-model="filter.district_administration"
              :options="administration_select"
              :multiple="true"
              :class="'form__field-select '"
            />
          </div>
          <div class="form__field mb-2">
            <div class="form__field-label">סוג המסגרת</div>
            <CustomThreeSelect
              v-model="filter.institution_type"
              :options="inst_types"
              :multiple="true"
              :class="'form__field-select '"
            />
          </div>
          <div class="form__field mb-2">
            <div class="form__field-label">יישוב</div>
            <CustomThreeSelect
              v-model="filter.city"
              :options="regions"
              :multiple="true"
              :class="'form__field-select '"
            />
          </div>
        </div>
        <button class="btn btn--blue btn--full" @click.stop="filtered">
          חפש
        </button>
      </div> -->
      <div style="position: relative">
        <div class="search">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
              stroke="#929BAA"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20 20L16 16"
              stroke="#929BAA"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <input
            v-model="search"
            :disabled="active_filter"
            type="text"
            :class="{ 'disabled__search-filter': active_filter }"
            class="custom__search"
            placeholder="הזן את השם"
            ref="searchInput"
            @click.stop
          />
          <!-- <button
              class="filter-button"
              @click.stop="active_filter = !active_filter"
            >
              <img v-if="filters_active" src="/images/filter-active.svg" />
              <img
                v-if="active_filter && !filters_active"
                src="/images/filter-open.svg"
              />
  
              <svg
                v-if="!filters_active && !active_filter"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 6H4L10.4 13.3578V18.4444L13.6 20V13.3578L20 6Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button> -->
        </div>
        <div class="sort-header"></div>
      </div>
      <div
        class="noOptionText"
        v-if="objAllItem && Array.isArray(objAllItem) && objAllItem.length == 0"
      >
        הרשימה ריקה
      </div>
      <ul
        @click.stop
        class="dropdown-list__users"
        :style="{ maxHeight: max_height + 'px' + ' ' + '!important' }"
        v-if="objAllItem && Array.isArray(objAllItem) && objAllItem.length > 0"
      >
        <li
          v-for="item in objAllItem"
          :key="item.id"
          class="dropdown-list__user"
          @click="selectitemSolo(item)"
        >
          <!-- <div class="dropdown-list__user-ava">
            <img v-avatar-placeholder :src="checkAvatar(item.img)" alt="" />
          </div> -->
          <div class="dropdown-list__user-content" @click="selectitem(item)">
            <div class="dropdown-list__user-title">
              <span
                :class="{
                  'selected-item-title':
                    selectedItem && selectedItem.id === item.id
                }"
                >{{ item.title }}
              </span>
              <!-- <span>{{ selectItems(item.user) }}</span> -->
            </div>
            <div
              v-if="item.district_administration"
              class="dropdown-list__user-subtitle"
              :class="{
                'selected-item-title':
                  selectedItem && selectedItem.id === item.id
              }"
            >
              {{
                item.district_administration
                  ? item.district_administration.title
                  : ''
              }}
              <!-- |
                  <b dir="ltr">
                    {{ item.user.class_name ? item.user.class_name : '-' }}</b
                  > -->
            </div>
          </div>
          <CheckboxNew
            v-if="multiply"
            :check="isSelected(item)"
            @checkedElem="selectitem(item)"
          />
          <!-- <div
            v-if="!withoutCheckbox"
            class="dropdown-list__user-checkbox"
            ></div> -->
        </li>
        <PaginationButton
          v-if="last_page > pageList && viewPagination"
          :countUsers="totalCount"
          :view-count="viewCount"
          @clickPagination="clickPagination"
        ></PaginationButton>
      </ul>
    </div>
    <!-- <div
            class="
              form__field-select-mupltiple form__field-select-wrap
              dropdown__list
            "
            :class="{
              for_inherit: for_inherit,
              for_inherit_vertical: for_inherit_vertical
            }"
          >
            <div
                  v-show="dropdownActive"
                  class="add__rows"
                  :class="{ vert: vertical }"
                ></div>
          </div> -->
  </div>
</template>
<script>
import CustomThreeSelect from '@/Components/UI/Form/CustomThreeSelect.vue';
import { myPlaginDebounce } from '@/Plugins/helper';
import PaginationButton from '../Buttons/PaginationButton.vue';
import CheckboxNew from '@/Components/UI/Form/CheckBoxModal.vue';
import checkBoxModal from '@/mixins/chekBoxModal.js';
import { multiply } from 'lodash';

export default {
  components: {
    // CustomThreeSelect,
    PaginationButton,
    CheckboxNew
  },
  mixins: [checkBoxModal],
  props: {
    inst_types: Array,
    administration_select: Array,
    fullWidth: Boolean,
    regions: Array,

    max_height: {
      type: [Number, String]
    },
    title: String,
    objAllItem: {
      type: Array,
      default: () => []
    },
    viewPagination: {
      type: Boolean,
      default: false
    },
    last_page: {
      type: Number
    },
    pageList: {
      type: Number
    },
    viewCount: {
      type: Number
    },
    totalCount: {
      type: Number
    },
    multiply: {
      type: Boolean,
      default: false
    },
    valueFilter: {
      type: Array,
      default: () => []
    },
    selectedInst: {
      type: Object,
      default: () => {
        return {};
      }
    },
    noSelected: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    selectedInstArray: {
      type: Array
    }
  },
  data() {
    return {
      filter: {
        district_administration: [],
        institution_type: [],
        city: []
      },

      active_filter: false,
      search: '',
      dropdownActive: false,
      filters_active: false,
      selectedItem: null,
      hoverActive: false,
      selectedItems: [],
      selectedElements: []
    };
  },

  watch: {
    valueFilter(val) {
      if (val.length == 0) {
        this.selectedItems = [];
        this.selectedElements = [];
      }
    },
    objAllItem(val) {
      if (
        Array.isArray(val) &&
        val.length > 0 &&
        !this.multiply &&
        this.selectedElements.length === 0 &&
        !this.noSelected
      ) {
        this.selectitemSolo(val[0]);
      }
      if (
        Array.isArray(this.selectedInstArray) &&
        this.selectedInstArray.length > 0
      ) {
        const selectedIds = this.selectedInstArray;
        this.selectedItems = this.selectedInstArray;
        // Ищем элементы по айдишникам и добавляем их в selectedElements
        this.selectedElements = this.objAllItem.filter(
          el => selectedIds.includes(Number(el.id)) // Преобразуем id в число для корректного сравнения
        );
      }
    },
    selectedInstArray(val) {
      if (Array.isArray(val) && val.length > 0) {
        const selectedIds = this.selectedInstArray;
        this.selectedItems = this.selectedInstArray;
        // Ищем элементы по айдишникам и добавляем их в selectedElements
        this.selectedElements = this.objAllItem.filter(
          el => selectedIds.includes(Number(el.id)) // Преобразуем id в число для корректного сравнения
        );
      }
    },

    search: myPlaginDebounce(function (newVal) {
      this.$emit('search', newVal);
    }, 700)
    // selectedInst(val) {
    //   if (val) {
    //     this.selectedItem = val;
    //   }
    // }
  },
  mounted() {
    if (this.selectedInstArray) {
      // Извлекаем идентификаторы из массива объектов
      const selectedIds = this.selectedInstArray;
      this.selectedItems = this.selectedInstArray;
      // Ищем элементы по айдишникам и добавляем их в selectedElements
      this.selectedElements = this.objAllItem.filter(el =>
        selectedIds.includes(el.id)
      );
    }
    // console.log('tyt');
    // document.addEventListener('click', this.handleClickOutside);
    // if (!localStorage.getItem('selectedInst')) {
    //   this.selectedItem = this.objAllItem[0];
    //   console.log(this.selectedItem);
    // } else {
    //   const id = JSON.parse(localStorage.getItem('selectedInst'));
    //   const inst = this.objAllItem.findItem(item => item.id === id);
    //   console.log(inst);
    //   if (inst) {
    //     this.selectedItem = inst;
    //   }
    // }
  },
  methods: {
    closeSelect() {
      this.dropdownActive = !this.dropdownActive;
    },
    checkAvatar(avatar) {
      if (avatar) {
        return avatar;
      } else {
        return '/images/cover.jpg';
      }
    },
    isSelected(item) {
      // Проверяем, выбран ли пользователь по его айдишнику
      return this.selectedItems.includes(Number(item.id));
    },
    selectitem(item) {
      if (multiply) {
        if (this.isSelected(item)) {
          this.selectedItems = this.selectedItems.filter(el => el !== item.id);
          this.selectedElements = this.selectedElements.filter(
            el => el.id !== item.id
          );
        } else {
          this.selectedElements.push(item);
          this.selectedItems.push(item.id);
        }
        this.$emit(
          'itemsSelected',
          this.selectedItems ? this.selectedItems : []
        );
      } else {
        this.$emit('itemsSelected', item);
        // this.dropdownActive = false;
      }
    },
    selectitemSolo(item) {
      if (this.multiply) {
        return;
      } else {
        const items = [];
        items.push(item);
        this.selectedElements = [...items];
        this.$emit('itemsSelected', item);
        this.dropdownActive = false;
      }
    },
    clickPagination() {
      this.$emit('clickPagination', this.search);
    },
    filtered() {
      this.$emit('filtered', this.filter);
      this.active_filter = false;
    },
    clear_filter() {
      this.search = '';
      this.filter = {
        district_administration: [],
        institution_type: [],
        city: []
      };
    },
    // selectItem(item, id) {
    //   this.selectedItem = item;
    //   this.$emit('select', id, item);
    //   //   this.dropdownActive = false;
    // },
    toggleDropdown() {
      if (this.disabled) {
        return;
      }
      this.dropdownActive = !this.dropdownActive;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target) && !this.active_filter) {
        this.dropdownActive = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.noOptionText {
  padding: 12px;
}
.select-title {
  padding: 0;
  font-family: 'Rubik';
  font-style: normal;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: right;
  color: #38455d;
  position: absolute;
  top: 0;
}
.multi-logo {
  display: flex;
  gap: 8px;
}
.scool-logo {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 4px;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
.dropdown__new-list {
  border-radius: 8px;
  display: flex;
  // padding-left: 18px;
  padding-right: 12px;
  direction: rtl;
  text-align: right;
  height: 48px;
  cursor: pointer;
  border: 1px solid #e3e7ee;
  transition: 0.3s;
}
.disabled-drop {
  background: #e3e7ee !important;
}
.more-avatars {
  color: #8e9ebb;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: right;
}
.dropdown-list__users {
  max-height: 222px;
}
.selected-item {
  background-color: #eef7ff;
}
.selected-item-title {
  color: #409fff;
}
.form__field-label {
  margin-bottom: 8px;
}
.filter-block__body .form__field:last-child {
  margin-bottom: 16px !important;
}
.dropdown__new-list {
  transition: background-color 0.6s ease, color 0.6s ease;
}
.dropdown__new-list:hover {
  // background-color: #eef7ff;
  // color: #409fff;
  transition: 0.3s;
  border: 1px solid #409fff;
}
.dropdown__new-list--active {
  // background-color: #eef7ff;
  // color: #0077ef !important;
  border: 1px solid #409fff;
}
.new-list {
  position: absolute;
  top: 30%;
  transform: scaleY(1);
  left: 12px;
  width: 16px;
  height: 16px;
}
.new-list.hovered path {
  transition: stroke 0.6s ease;
}
// .new-list.hovered path {
//   stroke: #409fff;
// }
.new-list--active {
  transform: rotate(180deg);
}
// .new-list--active path {
//   stroke: #0077ef !important;
// }
.dropdown__list__custom {
  width: 100%;
}

.three-select-schools__title {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: hidden;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: right;
  position: relative;
  width: 100%;
  span {
    padding-left: 12px;
    padding-top: 4px;
  }
}
.disabled__search-filter {
  background: #ebeef5;
  cursor: not-allowed;
}
.dropdown__new-list {
  position: relative;
}

.dropdown__list__custom {
  z-index: 11;
  top: 45px;
}

.checkbox-all__text {
  margin-left: 30px;
}
.dropdown-list {
  &__user {
    padding: 8px;
    text-decoration: none;
    border-radius: 4px;
  }
}
.expired_delay {
  background-color: #ffe8e6;
}
.active_use {
  background: #e5f2ff;
}
.active_green {
  background: #e6ffea;
}
.status__image {
  position: relative;
  left: 26px;
}

.filter-block {
  position: absolute;
  top: 58px;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 262px;
  background-color: #fff;
  padding: 12px 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
  opacity: 0;
  transition: 0.3s;
  pointer-events: none;
  box-shadow: 0px 2px 4px 0px rgba(56, 69, 93, 0.04),
    0px 4px 12px -2px rgba(56, 69, 93, 0.12);
  &.active {
    opacity: 1;
    pointer-events: all;
  }
  &__close-button {
    display: flex;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    margin-bottom: 8px;
    cursor: pointer;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  &__clear-button {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    border: none;
    background-color: transparent;
    padding: 8px 4px;
  }
  &__body {
    margin-bottom: auto;
  }
}

.search {
  position: relative;
  border: 1px solid #cfd3de;
  border-radius: 4px;
  margin: 8px;

  svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 8px;
  }
  input {
    border-radius: 4px;
    padding-right: 40px;
    &::placeholder {
      color: #cfd3de;
    }
  }
}

.filter-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  border-right: 1px solid #cfd3de;
  cursor: pointer;
}
.sort-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 0 8px 0 8px;
  &__label {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    b {
      font-weight: 500;
    }
  }
}

.checkbox-all {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  &__input {
    display: none;
    &:checked {
      .checkbox-all {
        &__marker {
          border-color: #7fbfff;
          background-color: #7fbfff;
        }
      }
    }
  }
  &__marker {
    width: 16px;
    height: 16px;
    border: 1px solid #cfd3de;
    border-radius: 2px;
    position: relative;
    flex-shrink: 0;
    transition: 0.3s;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url(/images/tire-icon.svg);
      background-position: center;
      background-size: contain;
    }
  }
  &__text {
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #7fbfff;
  }
}

// @media (max-width: 767px) {
//   .three-select-schools__title {
//     font-size: 28px;
//   }
// }

// @media (max-width: 470px) {
//   .three-select-schools__title {
//     font-size: 24px;
//   }
// }
</style>
